import { useState } from 'react';
import {
  Form,
  useNavigate,
  useNavigation,
  useActionData,
  redirectDocument,
} from 'react-router-dom';
import FileReader from 'react-native-filereader';

import classes from './EditService.module.css';
import { getAuthToken } from '../util/auth.jsx'
import backend from '../util/backend.jsx';

import LogoImage from './LogoImage.jsx';

import { initEditState, EDIT_OPEN } from '../util/advertiseEditState.jsx';

function EditService({ srv, editState, setEditState, setEditForm, newOrder = 0 }) {

  console.log(`EditService srv: ${srv.id} srv.display_order: ${srv.display_order} newOrder: ${newOrder}`);

  const data = useActionData();
  const navigate = useNavigate();
  const navigation = useNavigation();

  function initSelectedIcon(srv) {
    if ('icon_contents' in srv) {
      return srv.icon_contents;
    }
    return null;
  }

  function initSelectedIconFileType(srv) {
    if ('icon_filetype' in srv) {
      return srv.icon_filetype;
    }
    return null;
  }

  function initSelectedIconName(srv) {
    if ('icon_name' in srv) {
      return srv.icon_name;
    }
    return null;
  }

  function initUpdateIcon(srv) {
    if ('icon_filetype' in srv) {
      return !srv.icon_filetype.startsWith('image');
    }
    return true;
  }

  const [selectedIcon, setSelectedIcon] = useState(initSelectedIcon(srv));
  const [selectedIconFileType, setSelectedIconFileType] = useState(initSelectedIconFileType(srv));
  const [selectedIconName, setSelectedIconName] = useState(initSelectedIconName(srv));
  const [updateIcon, setUpdateIcon] = useState(initUpdateIcon(srv));
  const [insertIcon, setInsertIcon] = useState(initUpdateIcon(srv));

  const isSubmitting = navigation.state === 'submitting';

  function cancelHandler(event) {
    event.preventDefault();

    let newState = initEditState();
    setEditState(newState);
    setEditForm(false);

    navigate('/advertiseServices');
  }

  function toggleUpdateIcon() {
    setUpdateIcon(!updateIcon);
    srvInfoEditted();
  }

  const iconSelected = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    let image = null;
    const imageReader = new FileReader();
    imageReader.addEventListener('load', (event) => {
      image = event.target.result;
      const strImage = btoa(image);
      setSelectedIcon(strImage);
    });
    imageReader.readAsBinaryString(file);
    setSelectedIconFileType(file.type);
    setSelectedIconName(file.name);
    setInsertIcon(false);
    setUpdateIcon(false);
  };

  function srvInfoEditted() {
    //console.log(`srvInfoEditted before: ${JSON.stringify(editState)}`);
    let newState = initEditState();
    newState[EDIT_OPEN] = false;
    setEditState(newState);
    //console.log(`srvInfoEditted newState: ${JSON.stringify(newState)}`);
    //console.log(`srvInfoEditted after: ${JSON.stringify(editState)}`);
  }

  //if (srv) {
  // srvInfoEditted();
  //}
  //<div className={classes.form}>
  //<table className={classes.form}><tr><td>

  return (
    <Form method="post" className={classes.form}>
    <fieldset>
      <div>
        <input type="hidden" name="id" value={srv ? srv.id : ''} />
        <input type="hidden" name="display_order" value={newOrder ? newOrder : srv.display_order} />
        <p>
          <label htmlFor="title">Service Name</label>
          <input
            id="title"
            type="text"
            name="title"
            required
            defaultValue={srv ? srv.title : ''}
            onChange={srvInfoEditted}
          />
        </p>
        <p>
          <label htmlFor="description">Service Description</label>
          <textarea
            id="description"
            name="description"
            rows={15}
            cols={60}
            wrap="hard"
            required
            defaultValue={srv ? srv.description : ''}
            onChange={srvInfoEditted}
          />
        </p>
      </div>
      <div>
        <table>
        <tr>
        <td>
          {!insertIcon &&
            <table><tr><td>
              <input
                id="updateIcon"
                type="checkbox"
                name="updateIcon"
                checked={updateIcon}
                onChange={toggleUpdateIcon}
              />
            </td><td>
              <label htmlFor="image">Update Icon ({selectedIconName})</label>
            </td></tr></table>
          }
          {updateIcon &&
            <>
            <label htmlFor="image">Icon File</label>
            <input type="file" name="logo" onChange={iconSelected}  accept="image/*" />
            </>
          }
        </td>
        <td>
          {srv &&
            <LogoImage
              title={srv.title}
              logo_contents={selectedIcon}
              logo_filetype={selectedIconFileType}
            />
          }
        </td>
        </tr>
        </table>

        <input type="hidden" name="icon_contents" value={selectedIcon} />
        <input type="hidden" name="icon_filetype" value={selectedIconFileType} />
        <input type="hidden" name="icon_name" value={selectedIconName} />
      </div>
      <div>
        <p>
          <label htmlFor="website">Web Site</label>
          <input
            id="website"
            type="url"
            name="website"
            required
            defaultValue={srv ? srv.website : ''}
            onChange={srvInfoEditted}
          />
        </p>
      </div>
      <div className={classes.actions}>
        <button type="button" onClick={cancelHandler} disabled={isSubmitting}>
          Cancel
        </button>
        <button disabled={isSubmitting}>
          {isSubmitting ? 'Saving...' : 'Save'}
        </button>
      </div>
      {data && data.errors && (
        <ul>
          {Object.values(data.errors).map((error) => (
            <li className={classes.error} key={error}>{error}</li>
          ))}
        </ul>
      )}
    </fieldset>
    </Form>
  );
}

export default EditService;

export async function action({ request, params }) {
  console.log('EditService action: start');

  const method = request.method;
  const data = await request.formData();

  const srvData = {
    id:            data.get('id'),
    display_order: data.get('display_order'),
    title:         data.get('title'),
    description:   data.get('description'),
    website:       data.get('website'),
    icon_contents: data.get('icon_contents'),
    icon_filetype: data.get('icon_filetype'),
    icon_name:     data.get('icon_name'),
  };

  const token = getAuthToken();

  const response = await fetch(`https://${backend}/advertiseservice`, {
    method: method,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(srvData),
  });

  const result = await response.json();

  if (response.status === 422) {
    return {errors: [result.message]};
  }

  if (!response.ok) {
    return {errors: ['Could not save update.']};
  }

  return redirectDocument('/advertiseServices');
}
